import React from "react";
import classes from "./List.module.css";
import portfolioData from "../../data/portfolio.json";
import { isCompositeComponentWithType } from "react-dom/test-utils";

const List = () => {
  return (
    <ul className={classes["list-box"]}>
      {portfolioData.map((item) => {
        return (
          <li className={classes["list"]} key={item.idx}>
            <div>
              <ol className={classes["tags"]}>
                {item.tags.map((tag, idx) => {
                  return <li key={idx}>#{tag}</li>;
                })}
              </ol>
              <h3 className={classes["list-tit"]}>{item.title}</h3>
              <p className={classes["list-description"]}>{item.description}</p>




            </div>

            <div className={classes["links-box"]}>
                <h3>{item.title}</h3>
                <ul>
                  {item.links.map((link, idx) => {
                    return (
                      <li key={idx}>
                        <a href={link.url} target="_blank">{link.type}</a>
                      </li>
                    );
                  })}
                </ul>
              </div>

          </li>
        );
      })}
    </ul>
  );
};

export default List;
